import { useTranslation } from "react-i18next";
import { FeedCurve } from "../../../Services";
import { colors } from "../../../Styles";
import { MainContentPaddingTypes, NewButton, NewModal } from "../../BaseComponents";
import { useNavigate } from "react-router";
import { NavigationFunction as RootNavigation, } from "../../../Navigation/root";
import { GlobalMenu_Pages } from "../../../Navigation/pages";
import { FeedCurveWithLabels } from "../..";

interface ShowFeedCurveProps {
  farm: string
  handleClose: () => void;
  feedCurve: FeedCurve;
  navigateButton?: boolean;
  feedCurveMap?: {
    onNext?: () => void;
    onPrev?: () => void;
  } 
}

export default function ShowFeedCurve({ feedCurve, handleClose, feedCurveMap, navigateButton=false, farm }: ShowFeedCurveProps) {
  const { t } = useTranslation();
  const navigator = useNavigate()

  return (
    <NewModal
      overrides={{
        backgroundColor: colors.greyLightTertiary,
        mainContentPadding: MainContentPaddingTypes.primary,
        mainContentScroll: true
      }}
      predefinedButtons={{
        onClose: handleClose,
        onNext: feedCurveMap && feedCurveMap.onNext ? feedCurveMap.onNext : undefined,
        onPrev: feedCurveMap && feedCurveMap.onPrev ? feedCurveMap.onPrev : undefined,
      }}
      header={`${feedCurve.name}`}
      subHeader={`${t("feed.feedCurve.feedCurve", {defaultValue: "Feed Curve"})} ${feedCurve.feedCurveId}`}
      mainContent={
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px"}}>
          {feedCurve.milestones && ( <FeedCurveWithLabels data={feedCurve}/> )}
          { navigateButton && <NewButton
            content={t("feedCurvePages.feedCurves.goToFeedCurvePage", {defaultValue: "go to feedcurve page"})}
            onClick={() => {
              RootNavigation({ Navigator: navigator, navigation_page: GlobalMenu_Pages.feedCurves, navigation_tab: GlobalMenu_Pages.feedCurve, replace: true, navArgs: { selected: feedCurve?.feedCurveId }, currentDomain: farm })
            }}
          /> }
        </div>
      }
    />
  )
}